"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.functionsToExpose = void 0;
class Logger {
    constructor() {
        this.customTimingLogger = null;
    }
    setCustomTimingLogger(customTimingLogger) {
        this.customTimingLogger = customTimingLogger;
    }
    logCustomTiming(timing) {
        if (this.customTimingLogger) {
            this.customTimingLogger(timing);
        }
    }
}
const logger = new Logger();
exports.Logger = logger;
exports.functionsToExpose = {
    setCustomTimingLogger: (timingLogger) => {
        logger.setCustomTimingLogger(timingLogger);
    }
};
